import {
  Container,
  ArrowBlue,
  DocWhite,
  Line,
  CheckMarkIcon,
  EmptyMailBox,
  ActiveIcon,
  Loader
} from "../../../components";
import i18n from "../../../producers/i18n";
import { Box } from "../../../components/layout/Box";
import styles from "./styles.module.css";
import { EnvelopeResponse } from "../../../types/envelopeModel";

(window as any).showEnvelopeId = (show = true) => {
  const hidden = show ? '' : ' hidden';
  for (const item of document.getElementsByClassName('envelopeId')) {
    item.setAttribute('class', 'envelopeId' + hidden)
  }
}

const navigateToActionLink = (link: string, lang: string = "sv_SE") => {
  const url = new URL(link);
  if (url.searchParams.get("lang")) {
    url.searchParams.set("lang", lang);
  }
  location.href = url.toString();
}

export const Summary: view = ({
  envelopes = observe.envelopes,
  languageChoice = observe.languageChoice,
  ssn = observe.ssn,
  updateShouldLoadMore = update.shouldLoadMore,
  hasMore = observe.hasMore,
  isLoadingMore = observe.isLoadingMore,
}) => {

  const languageMap = {
    SE: "sv_SE",
    NO: "nb_NO",
    EN: "en_EN",
  };

  const formatDate = (date: string) => {
    return new Intl.DateTimeFormat().format(new Date(date || new Date()));
  }

  const getSigningMethod = (recipients: any) => {
    if (recipients[0].signingMethod === 'bankid-se') {
      return "BankID";
    } else if (recipients[0].signingMethod === 'email') {
      return "Email";
    } else if (recipients[0].signingMethod === 'sms') {
      return "SMS"
    } else {
      return "sign";
    }
  }

  const getFlowType = (envelope: any) => {
    switch (envelope.state.flow) {
      case 'hb-mortgage':
        return 'mortgage';
      case 'hb-standard':
        return 'standard';
      case 'hb-tax':
        return 'tax';
      default:
        return 'standard';
    }
  }

  const getEnevelopeCompletedBySelf = (state: any): boolean => {
    return !!state.recipients?.find(recipient => recipient.ssnNumber === ssn)?.completed
  }

  const envelopesList = (envelopes && envelopes.length > 0) ? envelopes.sort((a: any, b: any) => (a.publishDate > b.publishDate) ? 1 : -1).reverse() : [];
  return (
    <Container customInnerStyle={envelopes && envelopes.length === 0 ? styles.empptyInnerContainer : ''}>
      {envelopes && envelopes.length > 0
        ? envelopesList.map((envelope: EnvelopeResponse, index: number) => {
          const isAborted = !!envelope.state?.aborted;
          const isCompleted = !isAborted && envelope.completed;
          const noRejected = envelope.state?.documents?.filter(doc => doc.rejected).length;
          const isRejected = (noRejected > 0 && envelope.state?.documents.length === noRejected) ? true : false
          const showActionLink = !isAborted && !isRejected && envelope.actionLink && !getEnevelopeCompletedBySelf(envelope.state) || isCompleted;

          return (<Box key={index}>
            <div className="flex justify-between content-center flex-column items-end lg:items-center lg:flex-row">
              <div className="min-w-0 flex justify-center flex-col max-w-4xl w-[54rem]">
                <div className="text-primary-default-dark text-sm font-bold sm:text-lg break-words">
                  {i18n.t(`greeting.${getFlowType(envelope)}.part1`)}&nbsp;
                  {i18n.t(`greeting.${getFlowType(envelope)}.part2`)}&nbsp;
                  {envelope.state.sender.email}&nbsp;
                  {i18n.t(`greeting.${getFlowType(envelope)}.part3`)}&nbsp;
                  {i18n.t(`greeting.${getFlowType(envelope)}.part4`)}&nbsp;
                  {getSigningMethod(envelope.state.recipients)}
                </div>
                <div className="flex mt-4">
                  <div className={styles.iconStyle}>  
                    {(isAborted || isRejected) ? <div className={styles.aborted}></div> : isCompleted ? <CheckMarkIcon /> : <ActiveIcon />}
                  </div>
                  <div className={styles.statusStyle}>
                    {isRejected ? i18n.t("global.rejected") :
                      isAborted ? i18n.t("global.aborted") :
                        isCompleted
                          ? i18n.t("global.finalized")
                          : getEnevelopeCompletedBySelf(envelope.state)
                            ? i18n.t("global.pendingOthers")
                            : i18n.t("global.pendingActions")
                    }</div>
                  <div>•</div>
                  <div className={styles.envelopeDate}>{formatDate(envelope.publishDate)}</div>
                  <div className="envelopeId hidden"> • {envelope.envelopeId}</div>
                </div>
              </div>
              {showActionLink && <Line />}
              <div>
                {
                  showActionLink ?
                    isCompleted ? (
                      <button className="flex justify-between justify-center rounded-full py-4 pl-4 pr-4 sm:pr-12 lg:w-52 border border-solid border-primary-default-dark text-white bg-primary-default-dark font-medium hover:bg-blue-dark cursor-pointer"
                        onClick={() => navigateToActionLink(envelope.actionLink, languageMap[languageChoice])}
                      >
                        <div className="mr-2 hidden lg:block">{i18n.t("global.getDocuments")}</div>
                        <DocWhite />
                      </button>
                    ) : getEnevelopeCompletedBySelf(envelope.state) ? null : (
                      <button className="flex justify-between justify-center  rounded-full py-4 pl-4 pr-4 sm:pr-12 border lg:w-52 border-solid border-primary-default-dark text-primary-default-dark font-medium hover:bg-blue-dark hover:text-white cursor-pointer"
                        onClick={() => navigateToActionLink(envelope.actionLink, languageMap[languageChoice])}
                      >
                        <div className="mr-2 hidden lg:block">{i18n.t("global.viewProgress")}</div>
                        <ArrowBlue className="hover:text-white" />
                      </button>
                    ) : null}
              </div>
            </div>
          </Box>)
        })
        : (<div className={styles.emptyMailBox}>
          <div><EmptyMailBox /></div>
          <div>{i18n.t("review.no_envelopes_found")}</div>
        </div>
        )
      }

      {hasMore && 
        <div className="w-full flex justify-center">
          { 
          !isLoadingMore && <button className="justify-center rounded-full py-4 pl-4 pr-4 border lg:w-52 border-solid border-primary-default-dark text-primary-default-dark font-medium hover:bg-blue-dark hover:text-white cursor-pointer"
              onClick={() => updateShouldLoadMore.set(true)}
            >
              <div>Load More</div>
            </button>
          } 
          {
            isLoadingMore && <Loader />
          }
        </div>
      }

      <div>
        <a className={styles.privacyUrl} href={i18n.t("review.privacy_url")} target="_blank" >
          {i18n.t("review.privacy_url_title")}
        </a>
      </div>
    </Container >
  );
};
